module.exports = __webpack_public_path__ + "media/Experience.8e9a6249.mp4";